import {
    general as textsGeneral,
    shoppingCart as textsShoppingCart,
    paymentMethods as textsPaymentMethods,
    address as textsAddress
} from '../../../translate/Translate.jsx'

import './order.scss'

const Order = ({order}) => {
    return <div className={'order'}>
        <div className={'items'}>
            <label className={'title'}>
                {textsGeneral.items}
            </label>
            {order.itens.map((item, index) => <div key={index} className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {`${item.quantidade}x ${item.titulo}`}
                    </label>
                    <label className={'label'}>
                        {(item?.preco || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>
                <>
                    {item.subItens.map((subitem, index) => <div key={index} className={'div-content-item'}>
                        <div className={'item'}>
                            <label className={'label'}>
                                {`${subitem.quantidade}x ${subitem.titulo}`}
                            </label>
                            {(subitem.preco !== 0) && <label className={'label'}>
                                {(subitem?.preco || 0).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL'
                                })}
                            </label>}
                        </div>
                    </div>)}
                </>
            </div>)}
        </div>
        <div className={'items'}>
            <label className={'title'}>
                {textsGeneral.payment}
            </label>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsShoppingCart.subtotal}
                    </label>
                    <label className={'label'}>
                        {(order?.total_produtos || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>
            </div>
            {(!!order?.entrega && order.entrega !== 0) && <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsShoppingCart.deliveryFee}
                    </label>
                    <label className={'label'}>
                        {(order?.entrega || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>
            </div>}
            {(!!order?.desconto && order.desconto !== 0) && <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsShoppingCart.discount}
                    </label>
                    <label className={'label'}>
                        {(order?.desconto || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>
            </div>}
            {(!!order?.gularis_desconto && order?.gularis_desconto !== 0) && <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsShoppingCart.cashback}
                    </label>
                    <label className={'label'}>
                        {(order?.gularis_desconto || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>
            </div>}
            {(!!order?.troco && order.troco !== 0) && <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsPaymentMethods.change}
                    </label>
                    <label className={'label'}>
                        {(order?.troco || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>
            </div>}
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label-bold'}>
                        {textsShoppingCart.total}
                    </label>
                    <label className={'label-bold'}>
                        {(order?.total || 0).toLocaleString('pt-BR', {
                            style: 'currency',
                            currency: 'BRL'
                        })}
                    </label>
                </div>
            </div>
            {order.pagamentos.map((payment, index) => {
                return <div className={'div-content-item'} key={index}>
                    <div className={'item'}>
                        <label>

                        </label>
                        <label className={'label'}>
                            {(payment?.titulo || 0).toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            })}
                        </label>
                    </div>
                </div>
            })}
        </div>
        <div className={'items'}>
            <label className={'title'}>
                {textsGeneral.information}
            </label>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsGeneral.name}
                    </label>
                    <label className={'label'}>
                        {order.cliente.cliente_nome}
                    </label>
                </div>
            </div>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsGeneral.phone}
                    </label>
                    <label className={'label'}>
                        {order.cliente.cliente_telefone}
                    </label>
                </div>
            </div>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        N°
                    </label>
                    <label className={'label'}>
                        {`#${order?.id_pedido.slice(-4)}`}
                    </label>
                </div>
            </div>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {textsGeneral.orderType}
                    </label>
                    <label className={'label'}>
                        {(order.buscar) ? textsAddress.takeaway : textsAddress.delivery}
                    </label>
                </div>
            </div>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        Log Status
                    </label>
                    <label className={'label'}>
                        {order?.logStatus?.message || ''}
                    </label>
                </div>
            </div>
            {(!order?.buscar) && <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {`${order.cliente.endereco_rua}, ${order.cliente.endereco_numero} - ${order.cliente.endereco_bairro}, ${order.cliente.endereco_cidade} - ${order.cliente.endereco_uf}, ${order.cliente.endereco_cep} ${order.cliente.endereco_complemento}`}
                    </label>
                </div>
            </div>
            }
        </div>
        <div className={'items'}>
            <label className={'title'}>
                {textsGeneral.status}
            </label>
            <div className={'div-content-item'}>
                <div className={'item'}>
                    <label className={'label'}>
                        {`(${order.retorno.status}) - ${order?.retorno?.message || ''}`}
                    </label>
                </div>
            </div>
        </div>
    </div>
}

export default Order
